module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAOVJREFUWAntk0kKwkAURKOI7l2oJ3Djxpt5A6+iV3BaKngHhyu48QBZOFRBGppedfQLP1Ifigx0Kq8fSVFoZEAGZEAGZEAG/snAAJthXA7BTlXMINtGWyXQAZkY9ZnWBHMvtJ4RM3sWlCnc0KLUqiOGu6DULdwVcCOrXac9rfRGxjXNhR/igfM5cst4LixZ4ITf68/miGa+4NN06pDVWlwVz3DcI32EBpdIieTOM3fhN+umePiO0OIO6SHuJobcgq7rjhBAMeSmCZDrJkCuvEPy5xkjLoffJKORARmQARmQARnIM/AGNh04oKI8PeEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/carData/img/close.png
// module id = 1701
// module chunks = 0